import styles from './adminSurface.module.css';

/** Scopes the Admin page tokens to the page subtree inside the legacy content region. */
const AdminSurface = ({ children }) => (
    <div className={styles.root} data-admin-surface>
        {children}
    </div>
);

export default AdminSurface;
